export const CART_ID_STORAGE_KEY = 'shopifyCartId';
export const CART_COOKIE_TTL_DAYS = 14;

// Needed for cart analytics within Shopify
export const SHOPIFY_STOREFRONT_ID_HEADER = 'Shopify-Storefront-Id';
export const SHOPIFY_STOREFRONT_Y_HEADER = 'Shopify-Storefront-Y';
export const SHOPIFY_STOREFRONT_S_HEADER = 'Shopify-Storefront-S';
export const SHOPIFY_Y = '_shopify_y';
export const SHOPIFY_S = '_shopify_s';
